import {
  globalStyleTokens,
  inputTokens,
  pageTokens as defaultPageTokens,
} from '@agria/theme/src/const/tokens';

export { globalStyleTokens, inputTokens };

export const pageTokens = {
  ...defaultPageTokens,
  taxTextShowsStampDuty: true,
  showBothPricesBeforeSchedule: true,
} as const;
